module.exports = __webpack_public_path__ + "static/media/patient-favicon.d77c234c.ico";